module.exports = __webpack_public_path__ + "img/20200104130954270.bdb7c2de.jpg";